import {DatePicker} from "antd";


export default function (props){
    return <DatePicker style={{width: '100%'}} format={"DD/MM/YYYY"} {...props}/>
}